import { Box } from "@mui/material";
import MetabaseDashboard from "../components/Reportes/MetabaseDashboard";
import { environment } from "../config";
import { useAuthContext } from "../hooks/Auth";

export const ReportesPage = () => {
  const { REACT_APP_ADMIN_REPORTS } = environment;
  const { user } = useAuthContext();

  if (!user) return null;

  const dashboardUrl = (id: string) => {
    const base = `https://reportes.tuclase.net/public/dashboard/${id}`;
    return `${base}?useremail=${user.email}&paiscode=${user.pais}#hide_parameters=useremail,paiscode`;
  };

  return (
    <Box sx={{ width: "100%" }}>
      {/* Primer dashboard */}
      <MetabaseDashboard
        url={dashboardUrl("5ba3d7d6-2114-4fec-ac08-ca0f3b422209")}
      />

      {/* Segundo dashboard, se muestra solo si se cumplen las condiciones */}
      {user.email.endsWith("@tuclase.cl") && REACT_APP_ADMIN_REPORTS && (
        <Box sx={{ marginTop: 4 }}>
          <MetabaseDashboard
            url={dashboardUrl("5424ca81-e52b-4930-9d5e-b707cc406b1c")}
          />
        </Box>
      )}
    </Box>
  );
};
